import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, withKeys as _withKeys, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { id: "page" }
const _hoisted_2 = { class: "container-fluid breadcrumbs d-none d-md-block" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { "aria-label": "breadcrumb" }
const _hoisted_7 = { class: "breadcrumb" }
const _hoisted_8 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_9 = {
  id: "main",
  class: ""
}
const _hoisted_10 = { class: "container px-xs-0 beratung" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "login-heading" }
const _hoisted_13 = { class: "row login-content" }
const _hoisted_14 = {
  class: "mb-4",
  style: {"margin-bottom":"1rem !important"}
}
const _hoisted_15 = { class: "row" }
const _hoisted_16 = {
  class: "col-12 col-lg-4 mb-5 mb-lg-0",
  style: {"margin-bottom":"1rem!important"}
}
const _hoisted_17 = { class: "mb-4" }
const _hoisted_18 = {
  class: "form-label",
  for: "username"
}
const _hoisted_19 = { class: "mb-4" }
const _hoisted_20 = {
  class: "form-label",
  for: "password"
}
const _hoisted_21 = { class: "pw-input--wrapper" }
const _hoisted_22 = ["type"]
const _hoisted_23 = ["title", "aria-label"]
const _hoisted_24 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_25 = {
  class: "mb-5",
  style: {"margin-top":"1rem","margin-bottom":"0!important"}
}
const _hoisted_26 = { class: "col offset-lg-1" }
const _hoisted_27 = {
  class: "mb-4",
  style: {"margin-top":"0.5rem!important","font-size":"1.2em"}
}
const _hoisted_28 = { class: "onb-numbered-list" }
const _hoisted_29 = { class: "onb-numbered-list--item" }
const _hoisted_30 = { class: "onb-numbered-list--item" }
const _hoisted_31 = { class: "onb-numbered-list--item" }
const _hoisted_32 = { class: "onb-numbered-list--item" }
const _hoisted_33 = ["href"]
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { href: "https://www.frauenberatung.gv.at/" }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { href: "https://www.familienberatung.gv.at/" }
const _hoisted_38 = { class: "d-block pt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("nav", _hoisted_6, [
              _createElementVNode("ol", _hoisted_7, [
                _cache[6] || (_cache[6] = _createElementVNode("li", { class: "breadcrumb-item" }, [
                  _createElementVNode("a", { href: "#" }, "Home")
                ], -1)),
                _createElementVNode("li", _hoisted_8, _toDisplayString(_ctx.$t('views.login.breadcrumbpage')), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("main", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _cache[7] || (_cache[7] = _createElementVNode("i", {
              "aria-hidden": "true",
              class: "icon icon--user-solid"
            }, null, -1)),
            _createElementVNode("div", null, [
              _createElementVNode("h1", null, _toDisplayString(_ctx.$t('views.login.breadcrumbpage')), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("h2", _hoisted_14, _toDisplayString(_ctx.$t('views.login.logintext')), 1),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('views.login.username')), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
                  id: "username",
                  autocomplete: "off"
                }, null, 512), [
                  [_vModelText, _ctx.username]
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('views.login.password')), 1),
                _createElementVNode("div", _hoisted_21, [
                  _withDirectives(_createElementVNode("input", {
                    type: _ctx.passwordFieldType,
                    class: "form-control",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                    id: "password",
                    autocomplete: "off",
                    onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["enter"]))
                  }, null, 40, _hoisted_22), [
                    [_vModelDynamic, _ctx.password]
                  ]),
                  _createElementVNode("i", {
                    "data-target": "password",
                    class: _normalizeClass([_ctx.passwordFieldType === 'password' ? 'onb-visible--on': 'onb-visible--off', "icon pw-input--switch"]),
                    title: _ctx.passwordFieldType === 'password' ? _ctx.$t('views.login.showpw'): _ctx.$t('views.login.hidepw'),
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.togglePassword && _ctx.togglePassword(...args))),
                    "aria-label": _ctx.passwordFieldType === 'password' ? _ctx.$t('views.login.showpw') : _ctx.$t('views.login.hidepw')
                  }, null, 10, _hoisted_23)
                ])
              ]),
              _createElementVNode("button", {
                class: "btn btn-primary-custom mt-4 mb-4 me-4",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)))
              }, _toDisplayString(_ctx.$t('views.login.login')), 1),
              (_ctx.errorMessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.errorMessage), 1))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "btn btn-outline-primary-custom mt-4 mb-4 me-4",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.navigateToRegister && _ctx.navigateToRegister(...args)))
              }, _toDisplayString(_ctx.$t('views.login.newaccount')), 1),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("p", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('views.login.forgotpw')) + " ", 1),
                  _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('views.login.resetpw')) + " ", 1),
                  _createVNode(_component_router_link, { to: "/register" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('views.login.resetpw1')), 1)
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('views.login.resetpw2')), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("h4", _hoisted_27, _toDisplayString(_ctx.$t('views.login.sometext')), 1),
              _createElementVNode("ol", _hoisted_28, [
                _createElementVNode("li", _hoisted_29, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('views.login.sometext1')), 1)
                ]),
                _createElementVNode("li", _hoisted_30, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('views.login.sometext2')), 1)
                ]),
                _createElementVNode("li", _hoisted_31, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('views.login.sometext3')), 1)
                ]),
                _createElementVNode("li", _hoisted_32, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('views.login.sometext4')), 1)
                ])
              ]),
              _createElementVNode("a", {
                href: _ctx.getMoreLinkText(),
                class: "my-4 d-block"
              }, _toDisplayString(_ctx.$t('views.login.moreinfo')), 9, _hoisted_33),
              (_ctx.website == 'FAMILIE')
                ? (_openBlock(), _createElementBlock("strong", _hoisted_34, [
                    _createTextVNode(_toDisplayString(_ctx.$t('views.login.familienberatung')) + " ", 1),
                    _createElementVNode("a", _hoisted_35, _toDisplayString(_ctx.$t('views.login.familienberatung1')), 1),
                    _createTextVNode(_toDisplayString(_ctx.$t('views.login.registered')), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.website == 'FRAUEN')
                ? (_openBlock(), _createElementBlock("strong", _hoisted_36, [
                    _createTextVNode(_toDisplayString(_ctx.$t('views.login.frauenberatung')) + " ", 1),
                    _createElementVNode("a", _hoisted_37, _toDisplayString(_ctx.$t('views.login.frauenberatung1')), 1),
                    _createTextVNode(_toDisplayString(_ctx.$t('views.login.registered')), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("strong", _hoisted_38, _toDisplayString(_ctx.$t('views.login.dontsavetext')), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}